import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// 🛑 Prevent iframe embedding securely
if (window.self !== window.top) {
  document.body.innerHTML = "<h1>Embedding Not Allowed</h1>";
  window.stop(); // Stops further execution
  throw new Error("Embedding in iframes is not allowed.");
}

// 🌟 Wrap in StrictMode for better debugging
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// 🛠 Measure performance in your app (optional)
reportWebVitals();




// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.scss';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { BrowserRouter } from 'react-router-dom';
// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
// if (window.self !== window.top) {
//   document.body.innerHTML = "<h1>Embedding Not Allowed</h1>";
// }
// root.render(
//   <BrowserRouter>
//     <App />
//   </BrowserRouter>


// );
// reportWebVitals();